import { LiteUser } from './lite-user';

export class Roulage {
  id: number;
  type: string;
  participants: LiteUser[] = [];
  startDate: Date;
  endDate: Date;
  duration: string;
  kilometers: number;
  vehicleId: number;
  vehicleName: string;
  problems: string;
  formationMatter: string;

  responsible: LiteUser;
  reservationId: number;
  cmdMat: boolean;

  // La commande de matériel du roulage attend encore sa validation : le
  // véhicule n'est pas acquis.
  pending: boolean;

  constructor(data?: any) {
    if (data) {
      this.id = data.id;
      this.type = data.type;
      if (data.participants != null) {
        data.participants.forEach((user) =>
          this.participants.push(new LiteUser(user))
        );
      }
      this.startDate = new Date(data.startDate); // force for bsDatePicker
      this.endDate = new Date(data.endDate); // force for bsDatePicker
      this.duration = data.duration;
      this.kilometers = data.kilometers;
      this.vehicleId = data.vehicleId;
      this.vehicleName = data.vehicleName;
      this.problems = data.problems;
      this.formationMatter = data.formationMatter;
      if (data.responsible) {
        this.responsible = new LiteUser(data.responsible);
      }
      this.reservationId = data.reservationId;
      this.pending = data.pending;
    }
  }
}
